(function () {
  function initIngredientsSliders() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-iw-ingredients-slider]').forEach((root) => {
      if (root.dataset.iwIngredientsInitialized === 'true') return;

      const swiperEl = root.querySelector('.iw-ingredients__swiper');
      const paginationEl = root.querySelector('.iw-ingredients__swiper-pagination');
      const desktopSlider = root.dataset.desktopSlider === 'true';

      if (!swiperEl) return;

      const desktopBreakpoint = desktopSlider
        ? {
            slidesPerView: 3,
            spaceBetween: 24,
          }
        : {
            slidesPerView: 3,
            spaceBetween: 24,
            grid: {
              rows: 2,
              fill: 'row',
            },
            allowTouchMove: false,
          };

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: desktopBreakpoint,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });

      root.dataset.iwIngredientsInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIngredientsSliders);
  } else {
    initIngredientsSliders();
  }

  document.addEventListener('shopify:section:load', initIngredientsSliders);
})();
